import API from '../../services/api';

export const getLoggedInUserProfile = async () => {
  const response = await API.get('/auth/profile'); // Make sure your backend supports this route
  return response.data;
};

export const updateProfileUser = async (id, data) => {
  const response = await API.put(`/users/${id}`, data);
  return response.data;
};

export const changePassword = async (data) => {
  const response = await API.put('/auth/password', data);
  return response.data;
};